export class SelectOptionInterface {
    label: string;
    value: string | number | boolean;
    disabled?: boolean;
}
